import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select as ChakraSelect,
  Stack,
  Text,
  Textarea,
  useBreakpointValue,
} from "@chakra-ui/react";
import Select from "react-select";

import { useFormik } from "formik";
import { useEffect, useState, useMemo } from "react";
import { LiaMousePointerSolid } from "react-icons/lia";
import { TaskSchema } from "common/schema";
import { getApi, putApi } from "common/services/api";
import ContactModel from "common/components/commonTableModel/ContactModel";
import LeadModel from "common/components/commonTableModel/LeadModel";
import Spinner from "common/components/spinner/Spinner";
import moment from "moment";
import { toast } from "react-toastify";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { taskFormChange } from "services/Crm/utils/formChangeUtils";
import { crmConstant } from "services/Crm/constant";
import "common/assets/css/viewEdit.css";
import WhiteEditIcon from "common/assets/img/whiteEditIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";
import ColorPicker from "common/components/colorDropdown";
import colors from "common/theme/foundations/colors";
import { getCustomFieldData } from "common/redux/reducers/contactLeadSlice";
import SearchSelect from "common/components/autoComplete/AutoCompleteSelect";
const EditTask = (props) => {
  const {
    onClose,
    isOpen,
    fetchData,
    setAction,
    viewMode,
    setViewMode,
    permission,
    provideFormikConfig = () => { }
  } = props;
  const [isChecked, setIsChecked] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user"))._id;
  const user = JSON.parse(localStorage.getItem("user"));
  const [assignmentToData, setAssignmentToData] = useState([]);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoding, setIsDataLoding] = useState(false);
  const dispatch = useDispatch();
  const { contacts, leads, accounts } = useSelector(
    (state) => state.contactLead
  );
  const [list, setList] = useState({ deal: [], account: [] });
  const [relatedContacts, setRelatedContacts] = useState([]);

  const [userList, setUserList] = useState([]);
  const [userLoading, setUserLoading] = useState(false);

  useEffect(() => {
    dispatch(getContactList({ fetchAllData: true }));
    dispatch(getLeadList({ fetchAllData: true }));
  }, [dispatch]);

  const initialValues = {
    title: "",
    category: "None",
    description: "",
    // notes: "",
    assignmentTo: "",
    assignmentToLead: "",
    reminder: "",
    start: "",
    end: "",
    backgroundColor: "",
    borderColor: "#ffffff",
    textColor: "",
    display: "",
    url: "",
    allDay: "",
    status: "",
    createBy: userId,
    priority: "",
    assignmentToDeal: "",
    assignmentToAccount: "",
  };


  const { formik } = props;

  const fetchUserData = async () => {
    let result = await getApi("api/user/");
    setUserList(result?.data?.data);
  };
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  const EditData = async (values) => {
    if (values.category === "Contact" && !values.assignmentTo) {
      setAssignToError({
        ...assignToError,
        contact: "Please select contact",
      });
      return;
    }
    if (values.category === "Lead" && !values.assignmentToLead) {
      setAssignToError({
        ...assignToError,
        lead: "Please select lead",
      });
      return;
    }
    if (values.category === "Account" && !values.assignmentToAccount) {
      setAssignToError({
        ...assignToError,
        account: constant.accountErrorMsg,
      });
      return;
    }
    if (values.category === "Deal" && !values.assignmentToDeal) {
      setAssignToError({
        ...assignToError,
        deal: constant.dealErrorMsg,
      });
      return;
    }
    try {
      // Make a copy of the values
      const updatedPayload = { ...values };

      // If category is "None", reset assignmentTo and assignmentToLead
      if (updatedPayload.category === "None") {
        updatedPayload.assignmentTo = "";
        updatedPayload.assignmentToLead = "";
      }

      // Trim all string fields in the payload
      for (const key in updatedPayload) {
        if (typeof updatedPayload[key] === "string") {
          updatedPayload[key] = updatedPayload[key].trim();
        }
      }

      // Handle start and end date formatting
      if (updatedPayload?.start) {
        updatedPayload.start = isChecked
          ? moment(updatedPayload.start).format("YYYY-MM-DD") || ""
          : moment(updatedPayload.start).format("YYYY-MM-DDTHH:mm") || "";
      }
      if (updatedPayload?.end) {
        updatedPayload.end = isChecked
          ? moment(updatedPayload.end).format("YYYY-MM-DD") || ""
          : moment(updatedPayload.end).format("YYYY-MM-DDTHH:mm") || "";
      }

      // Make the API call
      setIsLoading(true);
      let response = await putApi(`api/task/edit/${props.id}`, updatedPayload);
      if (response.status === 200) {
        // fetchData()
        if (props.getData) {
          props.getData();
        }
        setAction((prev) => !prev);
        toast.success("Task updated successfully");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const [initialInfo, setInitialInfo] = useState(null);

  const fetchTaskData = async () => {
    if (props.id) {
      try {
        setIsDataLoding(true);
        let result = await getApi("api/task/view/", props.id);

        // Set the fetched data to Formik's values using setValues()
        const fetchedData = result?.data;
        // Use formik.setValues to set all initial values at once
        const resData = {
          title: fetchedData?.title || "",
          category:
            fetchedData?.category === constant.accounts
              ? "Account"
              : fetchedData?.category === constant.deals
                ? "Deal"
                : fetchedData?.category || "",
          description: fetchedData?.description || "",
          // notes: fetchedData?.notes || "",
          assignmentToAccount: fetchedData?.assignmentToAccount || "",
          assignmentToDeal: fetchedData?.assignmentToDeal || "",
          assignmentTo: fetchedData?.assignmentTo || null,
          reminder: fetchedData?.reminder || "",
          start: fetchedData?.start || "",
          end: fetchedData?.end || "",
          backgroundColor: fetchedData?.backgroundColor || "",
          borderColor: fetchedData?.borderColor || "",
          textColor: fetchedData?.textColor || "",
          display: fetchedData?.display || "",
          url: fetchedData?.url || "",
          status: fetchedData?.status || "",
          assignedToUser: fetchedData?.assignedToUser || "",
          assignmentToLead: fetchedData?.assignmentToLead || null,
          allDay: fetchedData?.allDay === "Yes" ? "Yes" : "No",
          priority: fetchedData?.priority || "not_defined",
        };
        const config = {
          initialValues: resData,
          validationSchema: TaskSchema,
          onSubmit: (values, { resetForm }) => {
            EditData(values);
          },
        };
        provideFormikConfig(config);
        formik.setValues(resData);
        getListDetails(fetchedData?.category);
        // Set the checkbox state based on the fetched value
        setIsChecked(fetchedData?.allDay === "Yes");

        // Optionally, set the initial values if you want to track the form's original state
        setInitialInfo(resData);
      } catch (e) {
        toast.error("Something went wrong");
      } finally {
        setIsDataLoding(false);
      }
    }
  };
  useEffect(() => {
    if (
      contacts?.length &&
      values.category &&
      values.assignmentTo &&
      (values.assignmentToDeal || values.assignmentToAccount)
    ) {
      const relatedItems = list[values.category.toLowerCase()]?.filter(
        (item) =>
          item._id ===
          (values.category === "Deal"
            ? values.assignmentToDeal
            : values.assignmentToAccount)
      );

      const contactIds = relatedItems?.flatMap((item) => item.contact || []);
      const uniqueContactIds = [...new Set(contactIds)];

      const matchedContacts = contacts
        ?.filter((c) => uniqueContactIds.includes(c._id))
        .map((contact) => ({
          value: contact._id,
          label: contact.contactName || "-",
        }));

      setRelatedContacts(matchedContacts || []);
    }
  }, [
    contacts,
    values.category,
    values.assignmentTo,
    values.assignmentToDeal,
    values.assignmentToAccount,
    list,
  ]);


  const hasChanges = useMemo(() => {
    return JSON.stringify(initialInfo) !== JSON.stringify(values);
  }, [initialInfo, values]);
  const [isSubmit, setIsSubmit] = useState(false);

  const [assignToError, setAssignToError] = useState({
    contact: "",
    lead: "",
    account: "",
    deal: "",
  });

  const getListDetails = async (value) => {
    try {
      let result = [];
      if (value === "Contact") {
        result = contacts;
      } else if (value === "Lead") {
        result = leads;
      } else if (value === "Account") {
        result = list.account;
      } else if (value === "Deal") {
        result = list.deal;
      }
      setAssignmentToData(result);
    } catch (e) {
      toast.error("Something went wrong");
    }
  };
  function onChangeHandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    setIsSubmit(false);
    handleChange(e);
  }
  const fetchDynamicData = async (id, type) => {
    let result = await getApi(
      user.role === "superAdmin"
        ? `api/form?moduleId=${id}&allData=true`
        : `api/form?moduleId=${id}&createBy=${user._id}&allData=true`
    );
    if (result.status === 200) {
      setList((prev) => ({ ...prev, [type]: result?.data?.data }));
    }
  };

  const fetchCustomDataFields = async (type) => {
    const result = await getApi(`api/custom-field/?moduleName=${type}`);
    const singaleData = result?.data?.find((item) => item?.moduleName === type);
    fetchDynamicData(singaleData?._id, type === "Deals" ? "deal" : "account");
  };
  useEffect(() => {
    fetchCustomDataFields("Deals");
    fetchCustomDataFields("Accounts");
    fetchUserData();
    fetchTaskData();
  }, []);

  function closeHandler() {
    setAssignToError({ lead: "", contact: "", account: "", deal: "" });
    setIsSubmit(false);
    formik.resetForm(); // Reset the form before closing
  }

  return (
    <>
      <Box className="manualFormContainer">
        <Box className="manualFormBody">
          {isDataLoding ? (
            <Flex justifyContent={"center"} alignItems={"center"} width="100%">
              <Spinner />
            </Flex>
          ) : (
            <Grid templateColumns="repeat(12, 1fr)" gap={3}>
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  Title<Text color={"red"}>*</Text>
                </FormLabel>
                <Input
                  disabled={viewMode}
                  fontSize="sm"
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  value={values.title}
                  name="title"
                  placeholder="Title"
                  fontWeight="500"
                  borderColor={
                    errors?.title && touched?.title ? "red.300" : null
                  }
                />
                <Text mb="10px" color={"red"} fontSize="sm">
                  {" "}
                  {errors.title && touched.title && errors.title}
                </Text>
              </GridItem>
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.dueDate}
                </FormLabel>
                <Input
                  disabled={viewMode}
                  type={isChecked === true ? "date" : "datetime-local"}
                  fontSize="sm"
                  min={values.start}
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  value={
                    isChecked
                      ? moment(values.end).format("YYYY-MM-DD") || ""
                      : moment(values.end).format("YYYY-MM-DDTHH:mm") || ""
                  }
                  name="end"
                  fontWeight="500"
                  borderColor={errors?.end && touched?.end ? "red.300" : null}
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.end && touched.end && errors.end}
                </Text>
              </GridItem>

              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.priority}
                </FormLabel>
                <ChakraSelect
                  disabled={viewMode}
                  onChange={(e) => {
                    setIsSubmit(false);
                    setFieldValue("priority", e.target.value);
                  }}
                  value={values.priority}
                >
                  {crmConstant.priorityList.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </ChakraSelect>

                <Text mb="10px" color={"red"}>
                  {errors.priority && touched.priority && errors.priority}
                </Text>
              </GridItem>

              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.status}
                </FormLabel>
                <ChakraSelect
                  disabled={viewMode}
                  onChange={(e) => setFieldValue("status", e.target.value)}
                  value={values?.status}
                  style={{ fontSize: "14px" }}
                >
                  <option value="completed">Completed</option>
                  <option value="todo">To Do</option>
                  <option value="onHold">On Hold</option>
                  <option value="inProgress">In Progress</option>
                  <option value="pending">Pending</option>
                </ChakraSelect>
              </GridItem>
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.assignToUser}
                  <Text color={colors.red["600"]}>*</Text>
                </FormLabel>
                {/* <ChakraSelect
                  disabled={viewMode}
                  onChange={(e) => {
                    setFieldValue("assignedToUser", e.target.value);
                  }}
                  value={values.assignedToUser}
                  placeholder={crmConstant.assignTo}
                >
                  {userList && userList.length > 0
                    ? userList.map((user) => {
                      return (
                        <option value={user._id}>
                          {user?.firstName ?? ""} {user?.lastName ?? ""}
                        </option>
                      );
                    })
                    : []}
                </ChakraSelect> */}
                <SearchSelect
                  disabled={viewMode}
                  loading={userLoading}
                  options={
                    userList?.map((user) => ({
                      value: user._id,
                      label: `${user.firstName ?? ""} ${user.lastName ?? ""}`,
                    })) || []
                  }
                  value={values.assignedToUser}
                  placeholder={crmConstant.assignTo}
                  onSelect={(option) => setFieldValue("assignedToUser", option.value)}
                />
                <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                  {errors.assignedToUser &&
                    touched.assignedToUser &&
                    errors.assignedToUser}
                </Text>
              </GridItem>
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.taskRelatedTo}
                </FormLabel>
                <ChakraSelect
                  disabled={viewMode}
                  onChange={(e) => {
                    setIsSubmit(false);
                    setFieldValue("category", e.target.value);
                    setFieldValue("assignmentTo", null);
                    setFieldValue("assignmentToLead", null);
                  }}
                  value={values.category}
                >
                  <option value={constant.none}>{constant.none}</option>
                  <option value={constant.contact}>{constant.contact}</option>
                  <option value={constant.lead}>{constant.lead}</option>
                  <option value={constant.account}>{constant.account}</option>
                  <option value={constant.deal}>{constant.deal}</option>
                </ChakraSelect>
                <Text mb="10px" color={"red"}>
                  {errors.category && touched.category && errors.category}
                </Text>
              </GridItem>
              {values.category === "Contact" ? (
                <>
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <FormLabel
                      display="flex"
                      ms="4px"
                      fontSize="sm"
                      fontWeight="500"
                      mb="8px"
                    >
                      Assign To Contact<Text color={"red"}>*</Text>
                    </FormLabel>
                    <SearchSelect
                      name="assignmentTo"
                      value={values.assignmentTo}
                      options={
                        contacts?.map((item) => ({
                          label: item.contactName || "-",
                          value: item._id,
                        })) || []
                      }
                      placeholder="Assign To"
                      disabled={viewMode}
                      onSelect={({ name, value: selectedValue }) => {
                        setFieldValue(name, selectedValue)

                        // setFieldValue("assignmentToLead", null)
                        // setFieldValue("assignmentToAccount", null)
                        // setFieldValue("assignmentToDeal", null)

                        onChangeHandler({ target: { name, value: selectedValue } })
                      }}
                      wrapperStyle={{
                        marginBottom:
                          errors.assignmentTo && touched.assignmentTo ? undefined : "10px",
                        border:
                          errors.assignmentTo && touched.assignmentTo ? "1px solid red" : undefined,
                      }}
                    />

                    {/* <ChakraSelect
                      disabled={viewMode}
                      value={values.assignmentTo}
                      name="assignmentTo"
                      onChange={(e) => {
                        // setFieldValue("assignmentToLead", null);
                        // setFieldValue("assignmentToAccount", null);
                        // setFieldValue("assignmentToDeal", null);
                        onChangeHandler(e);
                      }}
                      mb={
                        errors.assignmentTo && touched.assignmentTo
                          ? undefined
                          : "10px"
                      }
                      fontWeight="500"
                      placeholder={"Assign To"}
                      borderColor={
                        errors.assignmentTo && touched.assignmentTo
                          ? "red.300"
                          : null
                      }
                    >
                      {contacts?.map((item) => (
                        <option value={item._id} key={item._id}>
                          {values.assignmentTo === item._id
                            ? item?.contactName
                            : item?.contactName}
                        </option>
                      ))}
                    </ChakraSelect> */}
                    <Text mb="10px" fontSize="sm" color={"red"}>
                      {" "}
                      {assignToError.contact &&
                        !values.assignmentTo &&
                        isSubmit &&
                        "Please select contact"}
                    </Text>
                  </GridItem>
                </>
              ) : values.category === "Account" ? (
                <>
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <FormLabel
                      display="flex"
                      ms="4px"
                      fontSize="sm"
                      fontWeight="500"
                      mb="8px"
                    >
                      {constant.assignToAccount}
                      <Text color={colors.red["600"]}>*</Text>
                    </FormLabel>
                    {/* <ChakraSelect
                      disabled={viewMode}
                      value={values.assignmentToAccount}
                      name="assignmentToAccount"
                      onChange={(e) => {
                        // setFieldValue("assignmentToLead", null);
                        // setFieldValue("assignmentTo", null);
                        // setFieldValue("assignmentToDeal", null);
                        onChangeHandler(e);
                        const selectedValue = e.target.value;
                        const selectedItems = list[
                          values.category.toLowerCase()
                        ]?.filter((item) => item._id === selectedValue);
                        const contactIds = selectedItems?.flatMap(
                          (item) => item.contact || []
                        );
                        const uniqueContactIds = [...new Set(contactIds)];
                        const matchedContacts = contacts
                          ?.filter((c) => uniqueContactIds.includes(c._id))
                          .map((contact) => ({
                            value: contact._id,
                            label: contact.contactName || "-",
                          }));
                        setRelatedContacts(matchedContacts || []);
                      }}
                      mb={
                        errors.assignmentToAccount &&
                          touched.assignmentToAccount
                          ? undefined
                          : "10px"
                      }
                      fontWeight="500"
                      placeholder={"Assign To"}
                      borderColor={
                        errors.assignmentToAccount &&
                          touched.assignmentToAccount
                          ? "red.300"
                          : null
                      }
                    >
                      {list.account?.map((item) => {
                        return (
                          <option value={item._id} key={item._id}>
                            {item._id === values.assignmentToAccount
                              ? item?.accountName
                              : item?.accountName}
                          </option>
                        );
                      })}
                    </ChakraSelect> */}

                    <SearchSelect
                      name="assignmentToAccount"
                      value={values.assignmentToAccount}
                      options={
                        list.account?.map((item) => ({
                          label: item.accountName,
                          value: item._id,
                        })) || []
                      }
                      placeholder="Assign To"
                      disabled={viewMode}
                      onSelect={({ name, value: selectedValue }) => {
                        setFieldValue(name, selectedValue)

                        // Optional reset logic
                        // setFieldValue("assignmentToLead", null)
                        // setFieldValue("assignmentTo", null)
                        // setFieldValue("assignmentToDeal", null)

                        onChangeHandler({ target: { name, value: selectedValue } })

                        const selectedItems = list[values.category.toLowerCase()]?.filter(
                          (item) => item._id === selectedValue
                        )

                        const contactIds = selectedItems?.flatMap((item) => item.contact || [])
                        const uniqueContactIds = [...new Set(contactIds)]

                        const matchedContacts = contacts
                          ?.filter((c) => uniqueContactIds.includes(c._id))
                          .map((contact) => ({
                            value: contact._id,
                            label: contact.contactName || "-",
                          }))

                        setRelatedContacts(matchedContacts || [])
                      }}
                      wrapperStyle={{
                        marginBottom:
                          errors.assignmentToAccount && touched.assignmentToAccount
                            ? undefined
                            : "10px",
                        border:
                          errors.assignmentToAccount && touched.assignmentToAccount
                            ? "1px solid red"
                            : undefined,
                      }}
                    />

                    {assignToError.lead &&
                      !values.assignmentToAccount &&
                      isSubmit && (
                        <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                          {" "}
                          {assignToError.account &&
                            isSubmit &&
                            constant.accountErrorMsg}
                        </Text>
                      )}
                  </GridItem>
                </>
              ) : values.category === "Deal" ? (
                <>
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <FormLabel
                      display="flex"
                      ms="4px"
                      fontSize="sm"
                      fontWeight="500"
                      mb="8px"
                    >
                      {constant.assignToDeal}
                      <Text color={colors.red["600"]}>*</Text>
                    </FormLabel>
                    {/* <ChakraSelect
                      disabled={viewMode}
                      value={values.assignmentToDeal}
                      name="assignmentToDeal"
                      onChange={(e) => {
                        // setFieldValue("assignmentToLead", null);
                        // setFieldValue("assignmentTo", null);
                        // setFieldValue("assignmentToAccount", null);
                        onChangeHandler(e);
                        const selectedValue = e.target.value;
                        const selectedItems = list[
                          values.category.toLowerCase()
                        ]?.filter((item) => item._id === selectedValue);
                        const contactIds = selectedItems?.flatMap(
                          (item) => item.contact || []
                        );
                        const uniqueContactIds = [...new Set(contactIds)];
                        const matchedContacts = contacts
                          ?.filter((c) => uniqueContactIds.includes(c._id))
                          .map((contact) => ({
                            value: contact._id,
                            label: contact.contactName || "-",
                          }));

                        setRelatedContacts(matchedContacts || []);
                      }}
                      mb={
                        errors.assignmentToDeal && touched.assignmentToDeal
                          ? undefined
                          : "10px"
                      }
                      fontWeight="500"
                      placeholder={"Assign To"}
                      borderColor={
                        errors.assignmentToDeal && touched.assignmentToDeal
                          ? "red.300"
                          : null
                      }
                    >
                      {list.deal?.map((item) => {
                        return (
                          <option value={item._id} key={item._id}>
                            {item._id === values.assignmentToDeal
                              ? item?.dealName
                              : item?.dealName}
                          </option>
                        );
                      })}
                    </ChakraSelect> */}

                    <SearchSelect
                      name="assignmentToDeal"
                      value={values.assignmentToDeal}
                      options={
                        list.deal?.map((item) => ({
                          label: item.dealName,
                          value: item._id,
                        })) || []
                      }
                      placeholder="Assign To"
                      disabled={viewMode}
                      onSelect={({ name, value: selectedValue }) => {
                        // Set selected value
                        setFieldValue(name, selectedValue)

                        // 🔁 Reset other dependent fields
                        // setFieldValue("assignmentToLead", null)
                        // setFieldValue("assignmentTo", null)
                        // setFieldValue("assignmentToAccount", null)

                        // Trigger your onChange handler
                        onChangeHandler({ target: { name, value: selectedValue } })

                        // 🔗 Update related contacts
                        const selectedItems = list[values.category.toLowerCase()]?.filter(
                          (item) => item._id === selectedValue
                        )

                        const contactIds = selectedItems?.flatMap((item) => item.contact || [])
                        const uniqueContactIds = [...new Set(contactIds)]

                        const matchedContacts = contacts
                          ?.filter((c) => uniqueContactIds.includes(c._id))
                          .map((contact) => ({
                            value: contact._id,
                            label: contact.contactName || "-",
                          }))

                        setRelatedContacts(matchedContacts || [])
                      }}
                      wrapperStyle={{
                        marginBottom:
                          errors.assignmentToDeal && touched.assignmentToDeal
                            ? undefined
                            : "10px",
                        border:
                          errors.assignmentToDeal && touched.assignmentToDeal
                            ? "1px solid red"
                            : undefined,
                      }}
                    />

                    {assignToError.deal &&
                      !values.assignmentToDeal &&
                      isSubmit && (
                        <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                          {" "}
                          {assignToError.deal &&
                            isSubmit &&
                            constant.dealErrorMsg}
                        </Text>
                      )}
                  </GridItem>
                </>
              ) : values.category === "Lead" ? (
                <>
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <FormLabel
                      display="flex"
                      ms="4px"
                      fontSize="sm"
                      fontWeight="500"
                      mb="8px"
                    >
                      Assign To Lead<Text color={"red"}>*</Text>
                    </FormLabel>
                    {/* <ChakraSelect
                      disabled={viewMode}
                      value={values.assignmentToLead}
                      name="assignmentToLead"
                      onChange={(e) => {
                        // setFieldValue("assignmentTo", null);
                        // setFieldValue("assignmentToAccount", null);
                        // setFieldValue("assignmentToDeal", null);
                        onChangeHandler(e);
                      }}
                      mb={
                        errors.assignmentToLead && touched.assignmentToLead
                          ? undefined
                          : "10px"
                      }
                      fontWeight="500"
                      placeholder={"Assign To"}
                      borderColor={
                        errors.assignmentToLead && touched.assignmentToLead
                          ? "red.300"
                          : null
                      }
                    >
                      {leads?.map((item) => {
                        return (
                          <option value={item._id} key={item._id}>
                            {item._id === values.assignmentToLead
                              ? item?.leadName
                              : item?.leadName}
                          </option>
                        );
                      })}
                    </ChakraSelect> */}

                    <SearchSelect
                      name="assignmentToLead"
                      value={values.assignmentToLead}
                      options={
                        leads?.map((item) => ({
                          label: item.leadName || "-",
                          value: item._id,
                        })) || []
                      }
                      placeholder="Assign To"
                      disabled={viewMode}
                      onSelect={({ name, value: selectedValue }) => {
                        setFieldValue(name, selectedValue)

                        // setFieldValue("assignmentTo", null)
                        // setFieldValue("assignmentToAccount", null)
                        // setFieldValue("assignmentToDeal", null)

                        onChangeHandler({ target: { name, value: selectedValue } })
                      }}
                      wrapperStyle={{
                        marginBottom:
                          errors.assignmentToLead && touched.assignmentToLead ? undefined : "10px",
                        border:
                          errors.assignmentToLead && touched.assignmentToLead ? "1px solid red" : undefined,
                      }}
                    />


                    {assignToError.lead &&
                      !values.assignmentToLead &&
                      isSubmit && (
                        <Text mb="10px" fontSize="sm" color={"red"}>
                          {" "}
                          {assignToError.lead &&
                            isSubmit &&
                            "Please select lead"}
                        </Text>
                      )}
                  </GridItem>
                </>
              ) : (
                ""
              )}


              {(values.category === "Account" || values.category === "Deal") &&
                relatedContacts.length > 0 && (
                  <GridItem colSpan={{ base: 6 }}>
                    <FormLabel fontSize="sm" fontWeight="500" mb="8px">
                      {constant.selectContacts} {values.category}
                    </FormLabel>

                    {/* <Select
                        isDisabled={viewMode}
                        placeholder="Select related contact"
                        name="attendesContact"
                        options={relatedContacts}
                        onChange={(selected) => {
                          setFieldValue("assignmentTo", selected?.value || "");
                        }}
                        value={
                          relatedContacts.find(
                            (item) => item.value === values.assignmentTo
                          ) || null
                        }
                        className="basic-multi-select"
                        classNamePrefix="select"
                      /> */}

                    <SearchSelect
                      disabled={viewMode}
                      placeholder="Select related contact"
                      name="attendesContact"
                      options={relatedContacts}
                      value={relatedContacts.find(c => c.value === values.assignmentTo) || null}
                      onSelect={({ value: selectedValue }) => {
                        setFieldValue("assignmentTo", selectedValue);
                      }}

                      isMulti={false}
                    />


                    <Text mb="10px" color="red" fontSize="sm">
                      {errors.assignmentTo &&
                        touched.assignmentTo &&
                        errors.assignmentTo}
                    </Text>
                  </GridItem>
                )}

              <GridItem colSpan={{ base: 12 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  Description
                </FormLabel>
                <Textarea
                  disabled={viewMode}
                  resize={"none"}
                  fontSize="sm"
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  value={values.description}
                  name="description"
                  placeholder="Description"
                  fontWeight="500"
                  borderColor={
                    errors?.description && touched?.description
                      ? "red.300"
                      : null
                  }
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.description &&
                    touched.description &&
                    errors.description}
                </Text>
              </GridItem>

              <GridItem colSpan={{ base: 12, sm: 3 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.bgcolor}
                </FormLabel>
                {/* <Input
                  disabled={viewMode}
                  type="color"
                  fontSize="sm"
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  value={values.backgroundColor}
                  name="backgroundColor"
                  fontWeight="500"
                  borderColor={
                    errors?.backgroundColor && touched?.backgroundColor
                      ? "red.300"
                      : null
                  }
                  className="roundedColorInput"
                /> */}
                <ColorPicker
                  name="backgroundColor"
                  value={values.backgroundColor}
                  onSelect={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  errors={errors}
                  touched={touched}
                  disabled={viewMode}
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.backgroundColor &&
                    touched.backgroundColor &&
                    errors.backgroundColor}
                </Text>
              </GridItem>
              <GridItem colSpan={{ base: 12, sm: 3 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.borderolor}
                </FormLabel>
                {/* <Input
                  disabled={viewMode}
                  fontSize="sm"
                  type="color"
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  value={values.borderColor}
                  name="borderColor"
                  placeholder="borderColor"
                  fontWeight="500"
                  borderColor={
                    errors?.borderColor && touched?.borderColor
                      ? "red.300"
                      : null
                  }
                  className="roundedColorInput"
                /> */}
                <ColorPicker
                  name="borderColor"
                  value={values.borderColor}
                  onSelect={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  errors={errors}
                  touched={touched}
                  disabled={viewMode}
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.borderColor &&
                    touched.borderColor &&
                    errors.borderColor}
                </Text>
              </GridItem>
              <GridItem colSpan={{ base: 12, sm: 3 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.textColor}
                </FormLabel>
                {/* <Input
                  disabled={viewMode}
                  fontSize="sm"
                  type="color"
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  value={values.textColor}
                  name="textColor"
                  placeholder="textColor"
                  fontWeight="500"
                  textColor={
                    errors?.textColor && touched?.textColor ? "red.300" : null
                  }
                  className="roundedColorInput"
                /> */}
                <ColorPicker
                  name="textColor"
                  value={values.textColor}
                  onSelect={(e) => {
                    onChangeHandler(e);
                  }}
                  onBlur={handleBlur}
                  errors={errors}
                  touched={touched}
                  disabled={viewMode}
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.textColor && touched.textColor && errors.textColor}
                </Text>
              </GridItem>
            </Grid>
          )}
        </Box>
        {/* <Flex className="manualFormFooter">
          {viewMode ? (
            (user.role === "superAdmin" || permission?.update) && (
              <Button
                disabled={isLoading}
                onClick={() => setViewMode(false)}
                className="viewEditBtn"
              >
                <Image src={WhiteEditIcon} alt="edit" h={"16px"} w={"16px"} />
                {constant.edit}
              </Button>
            )
          ) : (
            <Flex gap={"16px"}>
              <Button
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  setViewMode(true);
                  formik.setValues(initialInfo);
                }}
                variant="outline"
                className="cancelBtn theme-btn2"
                size="sm"
              >
                {constant.cancel}
              </Button>

              <Button
                sx={{ textTransform: "capitalize" }}
                type="submit"
                disabled={
                  isLoading || !formik.isValid || !formik.dirty || !hasChanges
                }
                onClick={handleSubmit}
                className="viewEditBtn"
              >
                {constant.upload}
              </Button>
            </Flex>
          )}
        </Flex> */}
      </Box>

      {/* Contact Model  */}
      <ContactModel
        isOpen={contactModelOpen}
        data={assignmentToData}
        onClose={setContactModel}
        values={values}
        fieldName="assignmentTo"
        setFieldValue={setFieldValue}
      />
      {/* Lead Model  */}
      <LeadModel
        isOpen={leadModelOpen}
        data={assignmentToData}
        onClose={setLeadModel}
        values={values}
        fieldName="assignmentToLead"
        setFieldValue={setFieldValue}
      />
    </>
  );
};

export default EditTask;
